<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-table outlined 
                         sticky-column 
                         responsive
                         :fields="fields" 
                         :items="items" 
                         :busy="items == 0"
                         :current-page="currentPage" 
                         :per-page="perPage">
                         <div slot="table-busy" class="text-center my-2">
                            <strong>데이터가 없습니다.</strong>
                        </div>
                </b-table>
            </b-col>
            <b-col sm="12">
                <b-pagination v-model="currentPage" 
                            :totalRows="totalRows" 
                            :per-page="perPage"
                            align="center"></b-pagination>
            </b-col>
        </b-row>
    </div>
</template>
<script>
const moment = require("moment");

export default {
    name: "userLoginHistList",
    props: {
        userId: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            fields: [
                , { 'rnum': { 'label': '번호', thClass: 'thClass_w33', tdClass: 'textAlignCenter' } }
                , { 'login_date': { 'label': '로그인시간' , thClass: 'thClass_w33', tdClass: 'textAlignCenter' } }
                , { 'ip': { 'label': 'IP', thClass: 'thClass_w33', tdClass: 'textAlignCenter' } }
            ],
            items: [],
            currentPage: 1,
            perPage:10,
            totalRows:0,
            formModal: false,
            item: {},
            endDate: moment().format('YYYY-MM-DD'),
            startDate: moment().add(-365, 'days').format('YYYY-MM-DD'),
        }
    },
    watch: {
        userId: function (value, oldValue) {
            this.findLoginHistList();
        },
    },
    methods: {
        findLoginHistList() {
            var token = sessionStorage.getItem("myToken");
            this.$http.get('/api/select/userLoginLogList?access_token='+token
                                                + '&user_id=' + this.userId
                                                + '&startDate=' + this.startDate
                                                + '&endDate=' + this.endDate)
                .then((result) => {
                    const { data } = result;
                    this.items = data;
                    this.totalRows = this.items.length;
            })
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/views/user/userDetail/component/tabs/loginHistory/UserLoginHistList.vue